import PropTypes from "prop-types";
import _ from "lodash";
import { useRef, useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Box } from "@mui/material";
import StepIcon from "./StepIcon";
import StepIconPlus from "./StepIconPlus";
import StepConnector from "./StepConnector";
import StepScrollerWithButtons from "../StepScrollerWithButtons";
import "../../styles/ProgressStepIndicator.css";
import ShoppingCartTwoToneIcon from '@mui/icons-material/ShoppingCartTwoTone';
import { Link } from 'react-router-dom';

export default function ProgressStepIndicator({ steps = [], selected, onChange, refFromParent, ml ,isLink}) {
  //  selected = String(selected);
  const stepperRef = useRef(refFromParent);
  const [activeStepIndex, setActiveStepIndex] = useState(
    selected ? steps.indexOf(steps.find((step) => step.id === selected)) : 0
  );

  useEffect(() => {
    setActiveStepIndex(steps.indexOf(steps.find((step) => step.id === selected)));  //TODO:- I add New code Here !
  }, [selected]);
  // useEffect(() => {
  //   onChange?.(steps[activeStepIndex]?.id);
  // }, [activeStepIndex]);

  function getElementsArray() {
    const elements = stepperRef?.current?.children || [];
    return [...elements];
  }

  const param = new URLSearchParams(window.location.search);
  const PQID = param.get("pqid");




  function handleStepClick(step, event) {
    // var currentURL = window.location.href;

    // var urlWithoutSectionId = currentURL.replace(/([&?])sectionid=[^&]+&?/, '$1');
    // var newURL = urlWithoutSectionId + (urlWithoutSectionId.includes('?') ? '&' : '?') + 'sectionid=' + step.id;


    // if (event.ctrlKey) {
    //   window.open(newURL, '_blank');
    //   return;
    // }
    if (!step.disabled && selected != step.id) { //TODO:- we add (selected != step.id) i.e when cliced section twice output is blank
      setActiveStepIndex(steps.indexOf(step));
      onChange?.(step.id); //Todo:-add new code here!
    }
  }


  return (
    <StepScrollerWithButtons
      className="progress-stepper"
      getElementsArray={getElementsArray}
    >
      <Stepper
        nonLinear
        alternativeLabel
        activeStep={activeStepIndex}
        connector={<StepConnector ml={ml} />}
        ref={stepperRef}

      // sx={{marginLeft:ml?"100px":""}}
      >
        {steps.map((step, i) => (
          <Step
            className={`${step.status || "pristine"} ${i === activeStepIndex ? "active" : ""
              } ${step.disabled ? "disabled" : ""}`}
              as={isLink?Link:""}
              to={isLink?"/vendordetails?pqid="+PQID+"&sectionid="+step.id:""}
            completed={step.status === "completed"}
            key={step.id}
            onClick={(event) => handleStepClick(step, event)}
            title={step.disabledMessage || ""}
            sx={{ marginBottom: ml ? "" : "20px" ,}}
            style={{ textDecoration: 'none' }}
          >

            {step.forChecklist ? (
              <StepLabel
                StepIconComponent={step.id == 0 ? StepIconPlus : StepIcon}
                sx={{
                  marginTop: selected == step.id ? "-7px" : "",
                  marginLeft: selected == step.id ? "-10px" : "",
                  marginright: selected == step.id ? "-13px" : "",
                }}
              >
                <Box
                  sx={{
                    color: selected == step.id ? "var(--orange50)" : "",
                    fontWeight: selected == step.id ? "bolder" : "",
                    fontSize: selected == step.id ? "0.9rem" : "0.8rem",
                  }}
                >
                  {step.text}
                </Box>
                <Box
                  sx={{
                    color: selected == step.id ? "var(--orange50)" : "",
                    fontSize: selected == step.id ? "0.9rem" : "0.8rem",
                    display: step.metrics == "null/null" ? "none" : "",
                  }}
                >
                  {/* {step.metrics} */}
                </Box>
              </StepLabel>
            ) : ml ? (
              <div>
                <div className="text-center" style={{ marginBottom: "30px" }}>
                  {/* <ShoppingCartTwoToneIcon style={{  border: "3px solid green" ,padding:"10px",fontSize:"60px"}} /> */}
                  <span
                    style={{
                      backgroundcolor: "#F2F4F7",
                      borderRadius: "100%",
                      paddingTop: "25px",
                      paddingBottom: "25px",
                      paddingRight: "22px",
                      paddingLeft: "22px",
                      width: "64px",
                      height: "64px",
                      background:
                        selected == step.id ? "var(--orange20)" : "#F2F4F7",
                      color: selected == step.id ? "#fff" : "#667085",
                      marginRight: selected == step.id ? "10px" : "",
                    }}
                  >
                    {step.Img}
                  </span>
                </div>

                <StepLabel
                  StepIconComponent={StepIcon}
                  sx={{
                    marginTop: selected == step.id ? "-7px" : "",
                    marginLeft: selected == step.id ? "-10px" : "",
                    marginright: selected == step.id ? "-13px" : "",
                  }}
                >
                  <Box
                    sx={{
                      color: selected == step.id ? "var(--orange50)" : "",
                      fontWeight: selected == step.id ? "bolder" : "",
                      fontSize: selected == step.id ? "0.9rem" : "0.8rem",
                    }}
                  >
                    {step.text}
                  </Box>
                  <Box
                    sx={{
                      color: selected == step.id ? "var(--orange50)" : "",
                      fontSize: selected == step.id ? "0.9rem" : "0.8rem",
                      display: step.metrics == "null/null" ? "none" : "",
                    }}
                  >
                    {step.metrics}
                  </Box>
                </StepLabel>
              </div>
            ) : (
              <StepLabel
                StepIconComponent={StepIcon}
                sx={{
                  marginTop: selected == step.id ? "-7px" : "",
                  marginLeft: selected == step.id ? "-10px" : "",
                  marginright: selected == step.id ? "-13px" : "",
                }}
              >
                <Box
                  sx={{
                    color: selected == step.id ? "var(--orange50)" : "",
                    fontWeight: selected == step.id ? "bolder" : "",
                    fontSize: selected == step.id ? "0.9rem" : "0.8rem",
                  }}
                >
                  {step.text}
                </Box>
                <Box
                  sx={{
                    color: selected == step.id ? "var(--orange50)" : "",
                    fontSize: selected == step.id ? "0.9rem" : "0.8rem",
                    display: step.metrics == "null/null" ? "none" : "",
                  }}
                >
                  {step.metrics}
                </Box>
              </StepLabel>
            )}

            {/* <div className="step-content" >
                <div className="text-center" style={{marginBottom:"30px",}}>
                <ShoppingCartTwoToneIcon style={{  border: "3px solid green" ,padding:"10px",fontSize:"60px"}} /></div>
          
            <StepLabel StepIconComponent={StepIcon} sx={{ marginTop: selected == step.id ? "-7px" : "", marginLeft: selected == step.id ? "-10px" : "", marginright: selected == step.id ? "-13px" : "" }} >
              <Box sx={{ color: selected == step.id ? "var(--orange50)" : "", fontWeight: selected == step.id ? "bolder" : "", fontSize: selected == step.id ? "0.9rem" : "0.8rem" }}>{step.text}</Box>
              <Box sx={{ color: selected == step.id ? "var(--orange50)" : "", fontSize: selected == step.id ? "0.9rem" : "0.8rem",display:step.metrics=="null/null"?"none":"" }} >{step.metrics}</Box>
            </StepLabel>
          </div> */}

          </Step>

        ))}
      </Stepper>
    </StepScrollerWithButtons >
  );
}

ProgressStepIndicator.propTypes = {
  /**
   * Array of step definitions
   */
  steps: PropTypes.arrayOf(PropTypes.object),
  /**
   * Selected - id of selected step
   */
  selected: PropTypes.number, //TODO:-Mahesh PropTypes.string convert to PropTypes.number
  /**
   * Status: pristine or active or completed or disabled
   */
};